export default function EFTV(props: any) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M27.5 6H4.5C3.67157 6 3 6.67157 3 7.5V21.5C3 22.3284 3.67157 23 4.5 23H27.5C28.3284 23 29 22.3284 29 21.5V7.5C29 6.67157 28.3284 6 27.5 6Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M25.5 9H6.5C6.22386 9 6 9.22386 6 9.5V19.5C6 19.7761 6.22386 20 6.5 20H25.5C25.7761 20 26 19.7761 26 19.5V9.5C26 9.22386 25.7761 9 25.5 9Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M7 25.7991L8.5 23.201" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M25.5 25.7991L24 23.201" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
